import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { SvgCheck, SvgMinus } from '../../index';
import { Tick } from './Tick';
export function IndeterminedTick(props) {
    const inputRef = useRef(null);
    const handleClick = (e) => {
        let newValue;
        switch (props.isChecked) {
            case true:
                newValue = null;
                break;
            case null:
                newValue = false;
                break;
            case false:
                newValue = true;
                break;
        }
        props.onChange(e, { value: newValue, data: props.data });
    };
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = props.isChecked === null;
        }
    }, [props.isChecked]);
    const icon = props.isChecked === true ? _jsx(SvgCheck, {}) : props.isChecked === null ? _jsx(SvgMinus, {}) : undefined;
    return (_jsx(Tick, { type: props.isExclusive ? 'checkbox-exclusive' : 'checkbox', icon: icon, onClick: handleClick, children: _jsx("input", { ref: inputRef, type: 'checkbox', name: props.name, value: props.value, checked: props.isChecked === null || props.isChecked, readOnly: !!props.onChange }) }));
}
//# sourceMappingURL=IndeterminedTick.js.map